import React, { Component } from 'react';
import featureData from "../../data/feature";
import { Trans } from "react-i18next";

class Feature extends Component {
	constructor(props) {
		super(props);
		this.state = featureData;
	}

	render() {

		const featureItems = this.state.featureList.map( (item) => {
			return (
				<div key={item.id} className="col-lg-3 col-sm-6 col-md-6">
					<div className="single-features">
						<div className="features-icon d-flex align-items-center justify-content-center">
							<img
								src={item.imgUrl}
								alt=""
								className="animate"
								data-animate="rubberBand"
								data-duration="1s"
								data-delay="0.1s"
							/>
						</div>
						<div className="features-content">
							<h4>{item.heading}</h4>
							<div className="animate" data-animate="fadeIn" data-duration="1s" data-delay="0.2s">
								<p>{item.info}</p>
							</div>
						</div>
					</div>
				</div>
			);
		});

		return (
			<section className="features-area section-gap-top" id="features">
				<div className="container">
					<div className="row justify-content-center">
						<div className="col-lg-7 text-center">
							<div className="section-title">
								<span className="lines" />
								<h2><Trans i18nKey="feature.title" /></h2>
								<p><Trans i18nKey="feature.desc" /></p>
							</div>
						</div>
					</div>

					<div className="row">{featureItems}</div>
				</div>
			</section>
		);
	}

}
export { Feature };
